<template>
  <v-card
    v-show="admin.selectedComponent != null"
    loader-height="8"
    :loading="admin.componentsLoading"
    :disabled="admin.componentsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-toolbar color="blue" class="text-h4 text-uppercase" dark>
      Component Details
      <v-spacer></v-spacer>
      <v-icon>{{ app.systemIcon }}</v-icon>
    </v-toolbar>
    <v-tabs vertical right color="blue">
      <v-tab>Requirements</v-tab>
      <v-tab>Settings</v-tab>
      <v-tab-item>
        <requirement-list></requirement-list>
        <requirement-edit
          v-show="admin.selectedComponentRequirement != null"
        ></requirement-edit>
      </v-tab-item>
      <v-tab-item>
        <setting-list></setting-list>
        <setting-edit
          v-show="admin.selectedComponentSetting != null"
        ></setting-edit>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import RequirementList from './details/ComponentRequirementList.vue';
  import RequirementEdit from './details/ComponentRequirementEdit.vue';
  import SettingList from './details/ComponentSettingList.vue';
  import SettingEdit from './details/ComponentSettingEdit.vue';

  export default {
    components: { RequirementList, RequirementEdit, SettingList, SettingEdit },
    props: {
      minCardHeight: Number
    },
    data() {
      return {};
    },
    computed: {
      ...mapState(['app', 'admin'])
    }
  };
</script>
